<template>
  <div>
    <div class="container">
      <div class="content">
        <div class="content-top">
          <div class="title">
            <div class="invoiceType">
              <vxe-select
                  class="invoiceType"
                  style="width: 310px; height: 40px"
                  v-model="row.invoiceType"
                  placeholder="请选择"
                  :options="invoiceType"
                  transfer
                  v-if="isEdit"
              ></vxe-select>
              <div v-else style="height: 40px">
                {{
                  row.invoiceType == 1 || row.invoiceType == 2
                      ? invoiceType[row.invoiceType - 1].label
                      : "请选择"
                }}
              </div>
              <div class="line"></div>
              <div class="line"></div>
            </div>
            <div class="no">
              <img src="@/assets/images/common/no.png"/>
              <vxe-input
                  style="margin-left: 10px; width: 150px; height: 40px"
                  v-model="row.invoiceNum"
                  placeholder="必填"
                  v-if="isEdit"
              ></vxe-input>
              <span v-else style="width: 150px; text-align: center">{{ row.invoiceNum }}</span>
            </div>
          </div>
          <div class="tip">
            <div class="font-label">
              创建人:<span class="font-content" style="width: 70px; text-align: center">{{
                row.createUser
              }}</span>
            </div>
            <div
                class="font-label"
                style="margin-left: 20px"
                v-if="
              isHavePermission('invoice2.0:createTimeBuyer') ||
              isHavePermission('invoice2.0:createTimeSeller')
            "
            >
              创建时间：<span class="font-content" style="width: 94px; text-align: center">{{
                row.createTime
              }}</span>
            </div>
            <div class="font-label" style="position: absolute; left: 383px; top: 0">
              此联不作报销、扣税凭证使用
            </div>
            <div class="font-label" style="margin-left: auto">
              开票日期：
              <vxe-input
                  v-model="row.addTime"
                  placeholder="选择日期"
                  style="width: 120px"
                  type="date"
                  :editable="false"
                  transfer
                  v-if="isEdit"
              ></vxe-input>
              <span class="font-content" style="width: 120px" v-else>{{ row.addTime }}</span>
            </div>
            <div class="font-label" v-if="cate !== 'Sales'" style="margin-right: 10px">
              抵扣日期：
              <vxe-input
                  v-model="row.deductTime"
                  placeholder="选择日期"
                  style="width: 120px"
                  type="date"
                  :editable="false"
                  transfer
                  v-if="isEdit"
              ></vxe-input>
              <span class="font-content" style="width: 100px" v-else>{{ row.deductTime }}</span>
            </div>
          </div>
        </div>
        <div class="fp">
          <div style="width: 962px; display: flex; flex-direction: column">
            <div class="fp-top">
              <div class="gmf font-label right">购买方</div>
              <div class="gmf-content right">
                <div class="column">
                  <span class="gf-label">名称：</span>
                  <!--                <platform-corp-->
                  <!--                    style="border: 1px solid #DADADA;border-radius: 4px;width: 380px;height: 24px;line-height: 24px;cursor:pointer"-->
                  <!--                    class="plateForm"-->
                  <!--                    :row="row"-->
                  <!--                    :field="'invoiceTitle'"-->
                  <!--                    placeholder="请选择"-->
                  <!--                    @select="(val, index, obj) =>getInvoiceTitle(val, index, obj,'buyer')"-->
                  <!--                    v-if="cate === 'Income' && isEdit"-->
                  <!--                ></platform-corp>-->
                  <!--                <span class="fp-content" v-if="cate === 'Income' && !isEdit">-->
                  <!--                {{ row.invoiceTitle }}-->
                  <!--              </span>-->
                  <!--                <div v-if="cate === 'Sales' && isEdit" class="link-text"-->
                  <!--                     style="border: 1px solid #DADADA;border-radius: 4px;width: 380px;height: 24px;line-height: 24px;cursor:pointer"-->
                  <!--                     @click="openChooseAccount(row, 'invoiceTitle')">-->
                  <!--                  {{row.invoiceTitle == null || row.invoiceTitle === "" ? "请选择" : row.invoiceTitle }}-->
                  <!--                </div>-->
                  <!--                <span class="fp-content" v-if="cate === 'Sales' && !isEdit">-->
                  <!--                {{ row.invoiceTitle }}-->
                  <!--              </span>-->
                  <span class="fp-content">
                  {{ row.invoiceTitle }}
                </span>
                </div>
                <div class="column top">
                  <span class="gf-label">纳税人识别号：</span>
                  <span class="fp-content">{{ row.buyerTaxNum }}</span>
                </div>
                <div class="column top">
                  <span class="gf-label">地址、电话：</span>
                  <span class="fp-content">{{ row.buyerAddress }} {{ row.buyerMobile }}</span>
                </div>
                <div class="column top">
                  <span class="gf-label">开户行及帐号：</span>
                  <span class="fp-content">{{ row.buyerBankName }} {{ row.buyerAccountNum }}</span>
                </div>
              </div>
              <div class="ddxx font-label right">订单信息</div>
              <div class="ddxx-content">
                <div class="column top">
                  <span class="or-label">订单编号：</span>
                  <div
                      v-if="isEdit && ((row.ordersVersion === 2 || !row.ordersNum) || row.ordersVersion !== 4 || row.ordersVersion === 3)"
                      class="link-text"
                      style="
                    border: 1px solid #dadada;
                    border-radius: 4px;
                    width: 200px;
                    height: 24px;
                    line-height: 24px;
                    cursor: pointer;
                  "
                      @click="openOrder(row)"
                  >
                    {{ row.ordersNum ? row.ordersNum : "选择关联订单" }}
                  </div>
                  <span
                      v-else
                      class="fp-content"
                      style="cursor: pointer"
                      @click="openOrderDetail(row)"
                  >{{ row.ordersNum }}</span
                  >
                </div>
                <div class="column top">
                  <span class="or-label">托运人名称：</span>
                  <span class="fp-content">{{ row.buyerNameRela }}</span>
                </div>
                <div class="column top">
                  <span class="or-label">承运人名称：</span>
                  <span class="fp-content">{{ row.sellerNameRela }}</span>
                </div>
              </div>
            </div>
            <div class="fp-goods">
              <div class="goods-column right" style="width: 250px">
                <span class="font-label">货物或应税劳务、服务名称</span>
                <vxe-input
                    style="margin-top: 10px; width: 240px"
                    v-model="row.goodsName"
                    placeholder="必填"
                    v-if="isEdit"
                ></vxe-input>
                <span v-else class="fp-content" style="margin-top: 10px; height: 34px">{{
                    row.goodsName
                  }}</span>
                <span class="font-label" style="margin-top: auto">合计</span>
              </div>
              <div class="goods-column right" style="width: 120px">
                <span class="font-label">规格型号</span>
              </div>
              <div class="goods-column right" style="width: 55px">
                <span class="font-label">单位</span>
                <vxe-input
                    style="margin-top: 10px; width: 50px"
                    v-model="row.unit"
                    placeholder="选填"
                    v-if="isEdit"
                ></vxe-input>
                <span v-else class="fp-content" style="margin-top: 10px; height: 34px">{{
                    row.unit
                  }}</span>
              </div>
              <div class="goods-column right" style="width: 100px">
                <span class="font-label">数量</span>
                <vxe-input
                    style="margin-top: 10px; width: 90px"
                    v-model="row.counts"
                    placeholder="选填"
                    v-if="isEdit"
                    type="number"
                    v-on:input="calcMoney(row, 'counts')"
                ></vxe-input>
                <span v-else class="fp-content" style="margin-top: 10px; height: 34px">{{
                    row.counts
                  }}</span>
              </div>
              <div class="goods-column right" style="width: 100px">
                <span class="font-label">单价</span>
                <vxe-input
                    style="margin-top: 10px; width: 90px"
                    v-model="row.price"
                    placeholder="选填"
                    v-if="isEdit"
                    type="number"
                    min="0"
                    v-on:input="calcMoney(row, 'price')"
                ></vxe-input>
                <span v-else class="fp-content" style="margin-top: 10px; height: 34px">{{
                    row.price
                  }}</span>
              </div>
              <div class="goods-column right" style="width: 140px">
                <span class="font-label">金额</span>
                <vxe-input
                    style="margin-top: 10px; width: 130px"
                    v-model="row.totalAmount"
                    placeholder="必填"
                    v-if="isEdit"
                    type="number"
                    v-on:input="calcMoneyAll(row, 'totalAmount')"
                ></vxe-input>
                <span v-else class="fp-content" style="margin-top: 10px; height: 34px">{{
                    row.totalAmount
                  }}</span>
              </div>
              <div class="goods-column right" style="width: 60px">
                <span class="font-label">税率</span>
                <vxe-select
                    v-if="isEdit"
                    v-model="row.taxRate"
                    style="margin-top: 10px; width: 55px"
                    transfer
                >
                  <vxe-option
                      v-for="(item, index) in tax_rate"
                      :key="index"
                      :value="item.label"
                      :label="item.label"
                      @change="change(row)"
                  ></vxe-option>
                </vxe-select>
                <span v-else class="fp-content" style="margin-top: 10px; height: 34px"
                >{{ row.taxRate }}%</span
                >
              </div>
              <div class="goods-column" style="width: 140px">
                <span class="font-label">税额</span>
                <vxe-input
                    style="margin-top: 10px; width: 130px"
                    v-model="row.taxAmount"
                    placeholder="必填"
                    v-if="isEdit"
                    type="number"
                    v-on:input="calcMoneySecAll(row, 'taxAmount')"
                ></vxe-input>
                <span v-else class="fp-content" style="margin-top: 10px; height: 34px">{{
                    row.taxAmount
                  }}</span>
              </div>
            </div>
            <div class="fp-hj">
              <div class="goods-column right" style="width: 250px; justify-content: center">
                <span class="font-label">价税合计（大写）</span>
              </div>
              <div class="goods-column" style="width: 375px; justify-content: center">
                <span class="fp-content">{{ changeNumMoneyToChinese(row.taxTotalAmount) }}</span>
              </div>
              <div
                  class="goods-column"
                  style="width: 130px; align-items: flex-end; justify-content: center"
              >
                <span class="font-label">（小写）</span>
              </div>
              <div
                  class="goods-column"
                  style="width: 210px; align-items: flex-start; justify-content: center"
              >
                <vxe-input
                    v-model="row.taxTotalAmount"
                    placeholder="选填"
                    v-if="isEdit"
                    type="number"
                    v-on:input="calcMoneyTreAll(row, 'taxTotalAmount')"
                ></vxe-input>
                <span v-else class="fp-content">¥ {{ row.taxTotalAmount }}</span>
              </div>
            </div>
            <div class="fp-bottom">
              <div class="gmf font-label right">销售方</div>
              <div class="gmf-content right">
                <div class="column">
                  <span class="gf-label">名称：</span>
                  <!--                <platform-corp-->
                  <!--                    style="border: 1px solid #DADADA;border-radius: 4px;width: 380px;height: 24px;line-height: 24px;cursor:pointer"-->
                  <!--                    class="plateForm"-->
                  <!--                    :row="row"-->
                  <!--                    :field="'invoiceCompName'"-->
                  <!--                    :placeholder="'请选择'"-->
                  <!--                    @select="(val, index, obj) =>getInvoiceTitle(val, index, obj,'seller')"-->
                  <!--                    v-if="cate === 'Sales' && isEdit "-->
                  <!--                ></platform-corp>-->
                  <!--                <span class="fp-content" v-if="cate === 'Sales' && !isEdit">{{ row.invoiceCompName }}</span>-->
                  <span class="fp-content" v-if="cate === 'Sales'">{{ row.invoiceCompName }}</span>
                  <div
                      v-if="cate === 'Income' && isEdit"
                      class="link-text"
                      style="
                    border: 1px solid #dadada;
                    border-radius: 4px;
                    width: 380px;
                    height: 24px;
                    line-height: 24px;
                    cursor: pointer;
                  "
                      @click="openChooseAccount(row, 'invoiceCompName')"
                  >
                    {{
                      row.invoiceCompName === null || row.invoiceCompName === ""
                          ? "请选择"
                          : row.invoiceCompName
                    }}
                  </div>
                  <span class="fp-content" v-if="cate === 'Income' && !isEdit">
                  {{ row.invoiceCompName }}
                </span>
                </div>
                <div class="column top">
                  <span class="gf-label">纳税人识别号：</span>
                  <span class="fp-content">{{ row.sellerTaxNum }} </span>
                </div>
                <div class="column top">
                  <span class="gf-label">地址、电话：</span>
                  <span class="fp-content">{{ row.sellerAddress }} {{ row.sellerMobile }}</span>
                </div>
                <div class="column top">
                  <span class="gf-label">开户行及帐号：</span>
                  <span class="fp-content">{{ row.sellerBankName }} {{ row.sellerAccountNum }}</span>
                </div>
              </div>
              <div class="bz font-label right">备注</div>
              <div class="bz-content">
                <div class="column" style="height: 34px">
                  <span class="bz-label">车船号：</span>
                  <div
                      v-if="isEdit"
                      style="
                    width: 100px;
                    border: 1px solid #dadada;
                    border-radius: 4px;
                    height: 34px;
                    line-height: 34px;
                  "
                      class="link-text"
                      @click="showChooseCarShip(row)"
                  >
                    {{ row.carShipNum === null || row.carShipNum === "" ? "选填" : row.carShipNum }}
                  </div>
                  <span v-else class="fp-content" style="width: 100px">{{ row.carShipNum }}</span>
                  <span class="bz-label">起运日期：</span>
                  <vxe-input
                      style="width: 120px"
                      v-model="row.laydays"
                      placeholder="选填"
                      type="date"
                      transfer
                      v-if="isEdit"
                  ></vxe-input>
                  <span v-else class="fp-content" style="width: 120px">{{ row.laydays }}</span>
                </div>
                <div class="column" style="height: 34px; margin-top: 2px">
                  <span class="bz-label">起运地：</span>
                  <vxe-input
                      style="width: 100px"
                      v-model="row.beginPlace"
                      placeholder="选填"
                      v-if="isEdit"
                      maxlength="25"
                  ></vxe-input>
                  <span
                      :title="row.beginPlace"
                      v-else
                      class="fp-content text-overflow"
                      style="width: 100px"
                  >{{ row.beginPlace }}</span
                  >
                  <span class="bz-label">到达地：</span>
                  <vxe-input
                      style="width: 120px; margin-left: 16px"
                      v-model="row.endPlace"
                      placeholder="选填"
                      v-if="isEdit"
                      maxlength="25"
                  ></vxe-input>
                  <span
                      :title="row.endPlace"
                      v-else
                      class="fp-content text-overflow"
                      style="width: 120px"
                  >{{ row.endPlace }}</span
                  >
                </div>
                <div class="column" style="height: 34px; margin-top: 2px">
                  <span class="bz-label">备 注: </span>
                  <vxe-input
                      style="width: 312px; margin-left: 4px"
                      v-model="row.note"
                      placeholder="选填"
                      v-if="isEdit"
                  ></vxe-input>
                  <span
                      v-else
                      :title="row.note"
                      class="fp-content text-overflow"
                      style="width: 312px"
                  >{{ row.note }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="fp-right">第一联：记账联 销售方记账凭证</div>
        </div>
        <div class="content-bottom">
          <div class="bottom-tip" style="height: 35px">
            <div class="font-label">
              业务员：
              <sales-man
                  style="
                width: 120px;
                text-align: center;
                border: 1px solid #dadada;
                border-radius: 4px;
                height: 34px;
                line-height: 30px;
              "
                  class="salesMan"
                  v-if="isEdit"
                  :isEdit="isEdit"
                  :row="row"
                  :field="'salesMan'"
                  @setSaleMan="getSaleManInfo"
              ></sales-man>
              <span v-else class="font-content" style="width: 120px; text-align: center">{{
                  row.salesMan
                }}</span>
            </div>
            <div
                v-if="cate === 'Sales' && isHavePermission('invoice2.0:rateSeller')"
                class="font-label"
                style="margin-left: 35px"
            >
              费率(%)：
              <vxe-input
                  style="width: 80px"
                  v-model="row.rateManage"
                  placeholder=""
                  v-if="isEdit"
                  type="number"
                  v-on:input="calcMoneyTreAll(row, 'rateManage')"
              ></vxe-input>
              <span v-else class="font-content" style="width: 80px; text-align: center">{{
                  row.rateManage ? row.rateManage : ""
                }}</span>
            </div>
            <div
                v-if="cate === 'Income' && isHavePermission('invoice2.0:rateBuyer')"
                class="font-label"
                style="margin-left: 35px"
            >
              抵扣方式：
              <vxe-select
                  style="width: 80px"
                  v-model="row.deductType"
                  placeholder="请选择"
                  :options="deductType"
                  transfer
                  v-if="isEdit"
                  @change="changeDeductType(row)"
              ></vxe-select>
              <span v-else class="font-content" style="width: 80px; text-align: center">{{
                  row.deductType | deductMap
                }}</span>
            </div>
            <div
                v-if="cate === 'Income' && isHavePermission('invoice2.0:rateBuyer')"
                class="font-label"
                style="margin-left: 60px"
            >
              抵扣比例%：
              <vxe-input
                  style="width: 80px"
                  v-model="row.rateDeduct"
                  placeholder=""
                  type="number"
                  v-if="isEdit"
                  v-on:input="calcMoneyTreAll(row, 'rateDeduct')"
              ></vxe-input>
              <span v-else class="font-content" style="width: 80px; text-align: center">{{
                  row.rateDeduct
                }}</span>
            </div>
            <div
                class="font-label"
                style="margin-left: 60px"
                v-if="cate === 'Sales' && isHavePermission('invoice2.0:rateSeller')"
            >
              {{ cate === "Sales" ? "服务费" : "抵扣服务费" }}：
              <vxe-input
                  style="width: 80px"
                  v-model="row.manageAmount"
                  v-if="isEdit"
                  type="number"
                  v-on:input="calcMoneyTreAll(row)"
              ></vxe-input>
              <span v-else class="font-content" style="width: 80px; text-align: center">{{
                  row.manageAmount
                }}</span>
            </div>
            <div
                class="font-label"
                style="margin-left: 60px"
                v-if="cate === 'Income' && isHavePermission('invoice2.0:rateBuyer')"
            >
              {{ cate === "Sales" ? "服务费" : "抵扣服务费" }}：
              <vxe-input
                  style="width: 80px"
                  v-model="row.manageAmount"
                  v-if="isEdit"
                  type="number"
                  v-on:input="calcMoneyTreAll(row)"
              ></vxe-input>
              <span v-else class="font-content" style="width: 80px; text-align: center">{{
                  row.manageAmount
                }}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex; margin-top: 18px; height: 34px" v-if="cate === 'Sales' && !isMatching">
        <div class="kd">
          快递单号：
          <vxe-input
              style="width: 140px"
              v-model="row.logisticsNum"
              placeholder="选填"
              v-if="isEdit"
          ></vxe-input>
          <span v-else class="font-content" style="min-width: 140px">{{ row.logisticsNum }}</span>
        </div>
        <div class="kd" style="margin-left: 80px">
          快递公司：
          <vxe-input
              style="width: 140px"
              v-model="row.logisticsComp"
              placeholder="选填"
              v-if="isEdit"
          ></vxe-input>
          <span v-else class="font-content" style="min-width: 140px">{{ row.logisticsComp }}</span>
        </div>
      </div>
      <upload-table ref="uploadTable" style="margin-top: 20px;" :row="row"
                    :initFileList="row.fileList" :isEdit="isEdit"></upload-table>
      <div class="add-btn-box" v-if="isUpdate && authUpdate()">
        <!--      <Button v-if="isEdit" @click="isEdit = false">取消-->
        <!--      </Button>-->
        <Button type="primary" @click="submitEvent" v-if="isEdit">提交</Button>
        <Button
            type="primary"
            @click="editEvent"
            v-if="
          !isEdit &&
          (isHavePermission('invoice2.0:updateInvoiceSeller') ||
            isHavePermission('invoice2.0:updateInvoiceBuyer'))
        "
        >
          编辑
        </Button>
      </div>
    </div>
    <!-- 弹窗 -->
    <!-- 选择关联订单 -->
    <vxe-modal title="选择订单" v-model="isShowChooseOrder" width="1475" height="650" resize remember>
      <choose-invoice-order @chooseOrder="chooseOrderEvent" ref="chooseOrder"
                            :isSub="!isMatching" :isTax="isMatching"></choose-invoice-order>
    </vxe-modal>
    <!-- 选择企业 -->
    <vxe-modal
        title="选择用户"
        v-model="isShowChooseAccount"
        width="800"
        height="600"
        resize
        remember
    >
      <choose-account @choose="chooseAccountEvent" ref="chooseAccount"></choose-account>
    </vxe-modal>
    <!-- 选择车船 -->
    <vxe-modal
        title="选择车船"
        v-model="isShowChooseCarShip"
        width="1200"
        height="600"
        resize
        remember
    >
      <choose-car-ship ref="chooseCarShip" @choose="chooseCarShip"></choose-car-ship>
    </vxe-modal>
  </div>
</template>

<script>
import getAuthOrization from "@/mixin/getAuthOrization";
import SalesMan from "@/components/common/SalesMan";
import PlatformCorp from "@/components/common/PlatformCorp";
import ChooseInvoiceOrder from "@/components/proceduremodal/ChooseInvoiceOrder";
import UploadList from "@/components/common/UploadList";
import Account from "@/components/modal/Account";
import ChooseCarShip from "@/components/modal/ChooseCarShip";
import $C from "@/consts";
import $api from "@/apiProvider";
import {hideLoading, isEmpty, isNotEmpty, orderDetail, showLoading} from "@/utils/util";
import UploadTable from "@/components/modal/UploadTable";

const assign = (val) => Object.assign({}, val);
const empties = [undefined, "", null, "null", {}, []];

export default {
  mixins: [getAuthOrization],
  name: "Detail",
  components: {
    SalesMan,
    ChooseInvoiceOrder,
    ChooseAccount: Account,
    ChooseCarShip,
    UploadTable,
  },
  props: {
    cate: {
      type: String,
      default: "",
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    isUpdate: {
      type: Boolean,
      default: true,
    },
    isMatching: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dicByParentData: [],
      tax_rate: [],

      isShowChooseOrder: false,
      isShowChooseAccount: false,
      isShowChooseCarShip: false,

      invoiceType: $C.invoiceType.options,
      deductType: $C.deductType.options,
      isEdit: false,
      row: {
        manageAmount: null,
      },
      currentChooseColumn: "",
      tableData: [],
      editRules: {
        invoiceNum: [
          {
            validator: this.requireValid,
          },
        ],
        addTime: [
          {
            validator: this.requireValid,
          },
        ],
        invoiceCompName: [
          {
            validator: this.requireValid,
          },
        ],
        invoiceTitle: [
          {
            validator: this.requireValid,
          },
        ],
        goodsName: [
          {
            validator: this.requireValid,
          },
        ],
        // "counts": [{
        //   validator: this.requireValid
        // }],
        // "unit": [{
        //   validator: this.requireValid
        // }],
        // "price": [{
        //   validator: this.requireValid
        // }],
        taxRate: [
          {
            validator: this.requireValid,
          },
        ],
        taxAmount: [
          {
            validator: this.requireValid,
          },
        ],
        amount: [
          {
            validator: this.requireValid,
          },
        ],
      },
    };
  },
  watch: {
    isShow: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        //关闭弹窗
        if (val == false && oldVal == true) {
          this.isEdit = false;
        }
      },
    },
  },
  mounted() {
    this.getDictByCode(603, "tax_rate");
  },
  methods: {
    async queryUserOrCompanyInfo(userName, type) {
      let res = await $api.invoiceTwo.get("queryUserOrCompanyInfo", {
        userName: userName,
        nameType: type,
        invoiceType: this.cate === "Sales" ? 2 : 1,
      });
      if (res.status === 1) {
        let data = res.data;
        if (type === 1) {
          this.row.buyerTaxNum = data.taxNum;
          this.row.buyerAddress = data.address;
          this.row.buyerMobile = data.mobile;
          this.row.buyerBankName = data.bankName;
          this.row.buyerAccountNum = data.accountNum;
        } else {
          this.row.sellerTaxNum = data.taxNum;
          this.row.sellerAddress = data.address;
          this.row.sellerMobile = data.mobile;
          this.row.sellerBankName = data.bankName;
          this.row.sellerAccountNum = data.accountNum;
        }
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    openOrder(row) {
      this.row = row;
      this.isShowChooseOrder = true;
      this.$refs.chooseOrder.init();
    },
    openOrderDetail(row) {
      let id = row.ordersId;
      if (!this.isHavePermission("ordersTwo:detail")) {
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！",
        });
        return;
      }
      let obj;
      if (row.ordersVersion === 2) {
        obj = {
          name: `订单详情2.0-${id}`,
          path: `/order2/orderdetail/${id}`,
        };
      } else if (row.ordersVersion === 4) {
        let obj = {};
        obj.name = `附属订单详情${id}`
        obj.path = `/subOrder/orderdetail/${id}`
        window.open(obj.path);
      } else {
        obj = {
          name: `撮合订单详情-${id}`,
          path: `/matching/orderdetail/${id}`,
        };
      }

      // let obj = {
      //   name: `订单详情2.0-${id}`,
      //   path: `/order2/orderdetail/${id}`
      // };
      window.open(obj.path);
      // this.$store.dispatch("tagsView/addVisitedView", obj);
      // this.$router.push(obj.path);
      return false;
    },
    openChainOrder(row) {
      orderDetail(this, 0, row.chainId);
    },
    change(row) {
      this.calcMoneyAll(row);
    },
    async getDictByCode(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code,
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map((i) => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          });
        });
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    init(row) {
      this.getData(row.id);
    },
    initDetail(id) {
      this.getData(id);
    },
    async getData(id) {
      let queryAction;
      if (this.isMatching) {
        queryAction = 'queryInvoiceMatchDetail';
      } else {
        queryAction =
            this.cate === "Sales" ? "queryInvoiceSellerDetail" : "queryInvoiceBuyerDetail";
      }
      let res = await $api.invoiceTwo.request(queryAction, {
        id: id,
      });
      if (res.status === 1) {
        let row = res.data;
        if (row.laydays != null) {
          row.laydays = this.$utils.toDateString(row.laydays, "yyyy-MM-dd");
        }
        if (row.addTime != null) {
          row.addTime = this.$utils.toDateString(row.addTime, "yyyy-MM-dd");
        }
        if (row.deductTime != null) {
          row.deductTime = this.$utils.toDateString(row.deductTime, "yyyy-MM-dd");
        }
        if (row.createTime != null) {
          row.createTime = this.$utils.toDateString(row.createTime, "yyyy-MM-dd");
        }

        let salesManRes = await $api.baseUserSales.request("querySalesDetail", {
          id: row.salesManId,
          compName: row.compName,
        });
        if (salesManRes.status === 1) {
          if (salesManRes.data.rateList && salesManRes.data.rateList.length === 1) {
            row.orderRateDeduct = salesManRes.data.rateList[0].rateDeduct;
            row.orderRateDeductManage = salesManRes.data.rateList[0].rateDeductManage;
          }

        }
        row.fileListTwo = JSON.parse(JSON.stringify(row.fileList))

        if ((row.fileList == undefined || row.fileList == null || row.fileList.length == 0) && this.isEdit == false) {
          row.fileList = JSON.parse(JSON.stringify(row.relevanceFileList))
        }

        if (isEmpty(row.fileList) && undefined != this.$refs.uploadTable) {
          this.$refs.uploadTable.init([]);
        }
        this.row = row;
        this.tableData = [row];


      } else {
        if (empties.includes(res.message)) res.message = "接口异常";
        this.$XModal.message({
          status: "error",
          message: res.message,
        });
      }
    },
    changeDeductType(row) {
      // 1: 价税合计， 2：增值税
      // console.log(row, 'rrr');
      // debugger
      row.rateDeduct = row.deductType === 1 ? row.orderRateDeduct : row.orderRateDeductManage;
      this.calcMoneyTreAll(row);
      // row.rateDeduct = 1
    },
    getInvoiceTitle(val, index, row, type) {
      if (val) {
        this.row.rateDeduct = null;
        this.row.deductType = null;
        this.row.salesMan = null;
        this.row.rateManage = null;
        this.row.manageAmount = null;
      }
      if (type === "buyer") {
        this.row.buyerTaxNum = row.taxNum;
        this.row.buyerAddress = row.address;
        this.row.buyerMobile = row.mobile;
        this.row.buyerBankName = row.bankName;
        this.row.buyerAccountNum = row.accountNum;
      } else {
        this.row.sellerTaxNum = row.taxNum;
        this.row.sellerAddress = row.address;
        this.row.sellerMobile = row.mobile;
        this.row.sellerBankName = row.bankName;
        this.row.sellerAccountNum = row.accountNum;
      }
    },
    getSaleManInfo(val) {
      let row = this.tableData[0];
      row.orderRateDeduct = null;
      row.orderRateDeductManage = null;
      row.rateManage = null;
      row.rateDeduct = null;
      row.deductType = null;
      if (this.cate === "Sales") {
        if (row.invoiceCompName && val.rateList && val.rateList.length > 0) {
          let obj = val.rateList.filter((item) => item.compName == row.invoiceCompName);
          if (obj && obj.length > 0 && obj[0].rateManage) {
            row.rateManage = obj[0].rateManage;
          }
          this.calcMoney(row, "rateManage");
        }
      } else {
        if (row.invoiceTitle && val.rateList && val.rateList.length > 0) {
          let obj = val.rateList.filter((item) => item.compName == row.invoiceTitle);
          if (obj && obj.length > 0 && obj[0].rateManage) {
            row.orderRateDeduct = obj[0].rateDeduct;
            row.orderRateDeductManage = obj[0].rateDeductManage;
          }
        }
      }
    },
    getDicByParentList() {
      $api.other.getDicByParentModel
          .GET({
            params: {
              page: 1,
              rows: 10,
            },
          })
          .then((res) => {
            this.dicByParentData = res.data;
          });
    },
    editEvent() {
      this.isEdit = true;
      if (this.row.fileListTwo == null || this.row.fileListTwo.length == 0) {
        this.row.fileList = [];
      }
      if (isEmpty(this.row.fileList) && undefined != this.$refs.uploadList) {
        this.$refs.uploadList.init([]);
      }
      this.tableData = [this.row];
      this.$forceUpdate();
    },
    setEdit(isEdit) {
      this.isEdit = isEdit;
    },
    setUpdate(isUpdate) {
      this.isUpdate = isUpdate;
    },
    openChooseAccount(row, field) {
      if (!this.isEdit) {
        event.preventDefault();
        return this.needEdit();
      }
      this.currentChooseColumn = field;
      this.isShowChooseAccount = true;
      this.$refs.chooseAccount.init();
    },
    async chooseOrderEvent(order, type) {
      if (this.cate == "Sales") {
        // 开票
        if (type === 'matching') {
          this.row.ordersId = order.id;
          this.row.ordersNum = order.ordersNum;
          this.row.invoiceCompName = order.buyerName;
          this.row.invoiceTitle = order.sellerName;
          this.row.buyerNameRela = order.buyerName;
          this.row.sellerNameRela = order.sellerName;
        } else {
          this.row.ordersId = order.id;
          this.row.ordersNum = order.ordersNum;
          this.row.invoiceCompName = order.compName;
          this.row.platformCompanyId = order.platformCompanyId;
          this.row.invoiceTitle = order.buyerName;

          this.row.buyerNameRela = order.buyerName;
          this.row.sellerNameRela = order.compName;
        }
      } else {
        if (type === 'sub') {
          this.row.isSub = true;
          this.row.ordersId = order.id;
          this.row.ordersNum = order.ordersNumAttached;
          this.row.salesMan = order.saleMan;
          this.row.salesManId = order.saleManId;
          this.row.buyerNameRela = null;
          this.row.sellerNameRela = null;
        } else {
          this.row.isSub = false;
          // 抵扣票
          this.row.ordersId = order.id;
          this.row.ordersNum = order.ordersNum;
          this.row.invoiceCompName = order.sellerName;
          this.row.platformCompanyId = order.platformCompanyId;
          this.row.invoiceTitle = order.compName;

          this.row.buyerNameRela = order.compName;
          this.row.sellerNameRela = order.sellerName;
        }
      }
      if (!type) {
        this.queryUserOrCompanyInfo(this.row.invoiceTitle, 1);
        this.queryUserOrCompanyInfo(this.row.invoiceCompName, 2);

        this.row.buyerName = order.buyerName;
        this.row.sellerName = order.sellerName;

        // 会带入，开票单位、发票抬头、应税商品名称、数量、单位
        // this.row.invoiceCompName = order.sellerName
        // this.row.invoiceTitle = order.buyerName
        this.row.rateDeduct = order.rateDeduct;

        if (!this.isEdit) {
          if (!empties.includes(order.goodsRtnVos) && order.goodsRtnVos.length > 0) {
            this.row.goodsName = order.goodsRtnVos[0].goodsName;
            this.row.counts = order.goodsRtnVos[0].counts;
            this.row.unit = order.goodsRtnVos[0].unit;
          }
        }

        if (isNotEmpty(order.salesMan)) {
          this.row.salesMan = order.salesManName;
          this.row.salesManId = order.salesMan;
          this.row.isOrderSalesMan = true;
          // this.row.orderRateDeduct = order.rateDeduct
          // this.row.orderRateDeductManage = order.rateDeductManage
          let paramsObj;
          if (this.cate == "Sales") {
            paramsObj = {
              id: order.salesMan,
              compName: this.row.invoiceCompName,
            };
          } else {
            paramsObj = {
              id: order.salesMan,
              compName: this.row.invoiceTitle,
            };
          }

          let res = await $api.baseUserSales.request("querySalesDetail", paramsObj);
          if (res.status === 1) {
            if (res.data.rateList && res.data.rateList.length === 1) {
              this.row.orderRateDeduct = res.data.rateList[0].rateDeduct;
              this.row.orderRateDeductManage = res.data.rateList[0].rateDeductManage;
              this.row.rateManage = res.data.rateList[0].rateManage;
            } else {
              this.row.orderRateDeduct = null;
              this.row.orderRateDeductManage = null;
              this.row.rateManage = null;
            }
          }
          // console.log(this.row, 'this.row');
          // debugger
        }
      }
      this.isShowChooseOrder = false;
    },
    chooseAccountEvent(account, type) {
      console.log("chooseAccountEvent", account);
      if (type === 1) {
        this.row[this.currentChooseColumn] = account.compName;
        if (this.currentChooseColumn === "invoiceTitle") {
          this.row.buyerTaxNum = account.taxNum;
          this.row.buyerAddress = account.regAddr;
          this.row.buyerMobile = account.regPhone;
          this.row.buyerBankName = account.bankName;
          this.row.buyerAccountNum = account.accountNum;
        } else {
          this.row.sellerTaxNum = account.taxNum;
          this.row.sellerAddress = account.regAddr;
          this.row.sellerMobile = account.regPhone;
          this.row.sellerBankName = account.bankName;
          this.row.sellerAccountNum = account.accountNum;
        }
      } else {
        this.row[this.currentChooseColumn] = account.userName;
        if (this.currentChooseColumn === "invoiceTitle") {
          this.row.buyerTaxNum = "";
          this.row.buyerAddress = "";
          this.row.buyerMobile = "";
          this.row.buyerBankName = "";
          this.row.buyerAccountNum = "";
        } else {
          this.row.sellerTaxNum = "";
          this.row.sellerAddress = "";
          this.row.sellerMobile = "";
          this.row.sellerBankName = "";
          this.row.sellerAccountNum = "";
        }
      }
      this.isShowChooseAccount = false;
    },
    showChooseCarShip(row) {
      if (!this.isEdit) {
        event.preventDefault();
        return this.needEdit();
      }
      this.row = row;
      this.isShowChooseCarShip = true;
      this.$refs.chooseCarShip.init();
    },
    chooseCarShip(data, cate) {
      this.row.carShipNum = cate === "car" ? data.carNum : data.shipName;
      this.isShowChooseCarShip = false;
    },
    async submitEvent() {
      let row = assign(this.row);
      if (row.invoiceNum) {
        let rep8 = /^(\d{8})?$/;
        let rep20 = /^(\d{20})?$/;
        let invoiceNum = row.invoiceNum.trim();
        if (!rep8.test(invoiceNum) && !rep20.test(invoiceNum)) {
          this.$XModal.message("请输入正确的发票号码");
          return;
        }
      }

      if (this.cate === "Income" && isEmpty(row.deductTime)) {
        this.$XModal.message("抵扣日期不能为空");
        return;
      }
      if (isEmpty(row.invoiceNum)) {
        this.$XModal.message("发票号不能为空");
        return;
      }
      if (isEmpty(row.addTime)) {
        this.$XModal.message("开票日期不能为空");
        return;
      }
      if (isEmpty(row.invoiceCompName)) {
        this.$XModal.message("开票企业名称不能为空");
        return;
      }
      if (isEmpty(row.invoiceTitle)) {
        this.$XModal.message("发票抬头不能为空");
        return;
      }
      if (isEmpty(row.goodsName)) {
        this.$XModal.message("应税商品名称不能为空");
        return;
      }
      // if (isEmpty(row.counts)) {
      //   this.$XModal.message("应税商品数量不能为空");
      //   return;
      // }
      // if (isEmpty(row.unit)) {
      //   this.$XModal.message("单位不能为空");
      //   return;
      // }
      // if (isEmpty(row.price)) {
      //   this.$XModal.message("单价不能为空");
      //   return;
      // }
      if (isEmpty(row.taxRate)) {
        this.$XModal.message("税率不能为空");
        return;
      }
      if (isEmpty(row.taxAmount)) {
        this.$XModal.message("税额不能为空");
        return;
      }

      if (row.laydays != null && row.laydays !== "") {
        row.laydays = this.$utils.timestamp(this.$utils.toStringDate(row.laydays));
      }
      if (row.laydays === "Invalid Date") {
        row.laydays = null;
      }
      if (row.addTime) {
        row.addTime = this.$utils.timestamp(this.$utils.toStringDate(row.addTime));
      }
      if (row.deductTime) {
        row.deductTime = this.$utils.timestamp(this.$utils.toStringDate(row.deductTime));
      }
      if (row.cteateTime) {
        row.cteateTime = this.$utils.timestamp(this.$utils.toStringDate(row.cteateTime));
      }
      if (row.taxTotalAmount) {
        row.amount = row.taxTotalAmount;
      }
      row.clientManagerId = row.salesManKhId;

      row.compName = this.cate === "Sales" ? row.invoiceCompName : row.invoiceTitle;
      let action;
      if (this.isMatching) {
        action = 'updateInvoiceMatch';
      } else {
        action = this.cate === "Sales" ? "updateInvoiceSeller" : "updateInvoiceBuyer";
      }
      // row.ordersVersion = row.ordersVersion ? row.ordersVersion : 2;
      if (row.ordersVersion) {
        delete row.ordersVersion;
      }
      showLoading();
      let res = await $api.invoiceTwo.request(action, row);
      hideLoading();

      if (res.status === 1) {
        this.$XModal.message("提交成功");
        this.$emit("close");
        this.$emit("init");
      } else {
        if (!res.message) {
          res.message = "接口异常";
        }
        this.$XModal.message(res.message);
      }
    },
    needEdit() {
      this.$XModal.message("编辑状态下才可操作");
    },
    calcMoney(row) {
      if (row.counts !== "" && row.price !== "") {
        let priceAmount = Math.round(row.counts * row.price * 100) / 100;
        row.totalAmount = isNaN(parseInt(priceAmount)) ? "" : priceAmount;
        this.calcMoneyAll(row);
      } else {
        row.totalAmount = "";
      }
    },
    calcMoneyAll(row) {
      if (row.taxRate !== "" && row.totalAmount !== "") {
        row.taxAmount = Math.round(row.totalAmount * row.taxRate) / 100;
        this.calcMoneySecAll(row);
      } else {
        row.taxAmount = "";
      }
    },
    calcMoneySecAll(row) {
      if (row.taxAmount !== "" && row.totalAmount !== "") {
        row.taxTotalAmount =
            Math.round((parseFloat(row.taxAmount) + parseFloat(row.totalAmount)) * 100) / 100;
        this.calcMoneyTreAll(row);
      } else {
        row.taxTotalAmount = "";
      }
    },
    calcMoneyTreAll(row) {
      let rate = "";
      if (this.cate === "Income") {
        rate = row.rateDeduct;
      } else {
        rate = row.rateManage;
        row.deductType = 1;
      }
      rate = isNaN(parseInt(rate)) ? "" : rate;

      if (!row.deductType) {
        return;
      }

      if (row.deductType === 1) {
        if (rate !== "" && row.taxTotalAmount !== "") {
          row.manageAmount = Math.round(row.taxTotalAmount * rate) / 100;
        } else {
          row.manageAmount = "";
        }
      } else {
        if (rate !== "") {
          row.manageAmount = Math.round(row.taxAmount * rate) / 100;
        } else {
          row.manageAmount = "";
        }
      }
    },
    authUpdate() {
      return (
          (this.cate === "Sales" && this.isHavePermission("invoice:updateInvoiceSeller")) ||
          (this.cate === "Income" && this.isHavePermission("invoice:updateInvoiceBuyer"))
      );
    },
    changeNumMoneyToChinese(money) {
      let cnNums = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"]; //汉字的数字
      let cnIntRadice = ["", "拾", "佰", "仟"]; //基本单位
      let cnIntUnits = ["", "万", "亿", "兆"]; //对应整数部分扩展单位
      let cnDecUnits = ["角", "分", "毫", "厘"]; //对应小数部分单位
      let cnInteger = "整"; //整数金额时后面跟的字符
      let cnIntLast = "元"; //整型完以后的单位
      let maxNum = 999999999999999.9999; //最大处理的数字
      let IntegerNum; //金额整数部分
      let DecimalNum; //金额小数部分
      let ChineseStr = ""; //输出的中文金额字符串
      let parts; //分离金额后用的数组，预定义
      let Symbol = ""; //正负值标记
      if (money === "") {
        return "";
      }
      money = parseFloat(money);
      if (money >= maxNum) {
        alert("超出最大处理数字");
        return "";
      }
      if (money === 0) {
        ChineseStr = cnNums[0] + cnIntLast + cnInteger;
        return ChineseStr;
      }
      if (money < 0) {
        money = -money;
        Symbol = "负 ";
      }
      money = money.toString(); //转换为字符串
      if (money.indexOf(".") === -1) {
        IntegerNum = money;
        DecimalNum = "";
      } else {
        parts = money.split(".");
        IntegerNum = parts[0];
        DecimalNum = parts[1].substr(0, 4);
      }
      if (parseInt(IntegerNum, 10) > 0) {
        //获取整型部分转换
        let zeroCount = 0;
        let IntLen = IntegerNum.length;
        for (let i = 0; i < IntLen; i++) {
          let n = IntegerNum.substr(i, 1);
          let p = IntLen - i - 1;
          let q = p / 4;
          let m = p % 4;
          if (n === "0") {
            zeroCount++;
          } else {
            if (zeroCount > 0) {
              ChineseStr += cnNums[0];
            }
            zeroCount = 0; //归零
            ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
          }
          if (m === 0 && zeroCount < 4) {
            ChineseStr += cnIntUnits[q];
          }
        }
        ChineseStr += cnIntLast;
        //整型部分处理完毕
      }
      if (DecimalNum !== "") {
        //小数部分
        var decLen = DecimalNum.length;
        for (let i = 0; i < decLen; i++) {
          let n = DecimalNum.substr(i, 1);
          if (n !== "0") {
            ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
          }
        }
      }
      if (ChineseStr === "") {
        ChineseStr += cnNums[0] + cnIntLast + cnInteger;
      } else if (DecimalNum === "") {
        ChineseStr += cnInteger;
      }
      ChineseStr = Symbol + ChineseStr;

      return ChineseStr;
    },
  },
};
</script>
<style scoped>
.container {
  background: #ffffff;
  padding: 25px 65px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.content {
  width: 1041px;
  /*height: 641px;*/
  border: 1px solid #cccccc;
  box-sizing: border-box;
}

.content-top {
  /*height: 125px;*/
  background: url("~assets/images/common/yz.png") center no-repeat;
  padding-top: 27px;
  position: relative;
}

.title {
  display: flex;
  align-items: center;
  justify-content: center;
}

.line {
  margin-top: 5px;
  width: 310px;
  height: 2px;
  background: #d3d3d4;
}

.invoiceType {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  font-family: FangSong, sans-serif;
  font-weight: 600;
  color: #231815;
}

.no {
  position: absolute;
  right: 123px;
  top: 39px;
  display: flex;
  align-items: center;
}

.no span {
  margin-left: 10px;
  font-size: 24px;
  font-family: Microsoft YaHei, sans-serif;
  font-weight: 400;
  color: #3346a2;
}

.tip {
  position: relative;
  margin-top: 8px;
  margin-left: 40px;
  display: flex;
  align-items: center;
}

.bottom-tip {
  margin-top: 5px;
  padding: 0 50px;
  display: flex;
  align-items: center;
}

.font-label {
  font-size: 16px;
  font-family: FangSong, sans-serif;
  font-weight: 600;
  color: #352e2c;
  display: flex;
  align-items: center;
}

.gf-label {
  font-size: 16px;
  font-family: FangSong, sans-serif;
  font-weight: 600;
  color: #352e2c;
  min-width: 115px;
}

.or-label {
  font-size: 16px;
  font-family: FangSong, sans-serif;
  font-weight: 600;
  color: #352e2c;
  min-width: 90px;
}

.bz-label {
  font-size: 16px;
  font-family: FangSong, sans-serif;
  font-weight: 600;
  color: #352e2c;
  min-width: 52px;
}

.fp-content {
  font-size: 12px;
  font-family: Microsoft YaHei, sans-serif;
  font-weight: 600;
  color: #3346a2;
}

.font-content {
  font-size: 12px;
  font-family: Microsoft YaHei, sans-serif;
  font-weight: 600;
  color: #3346a2;
  line-height: 40px;
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fp {
  width: 965px;
  height: 465px;
  border: 2px solid #231815;
  margin-left: 40px;
  margin-top: 2px;
  display: flex;
}

.fp-top {
  display: flex;
  height: 110px;
  border-bottom: 2px solid #231815;
}

.fp-bottom {
  display: flex;
  height: 100%;
}

.fp-goods {
  display: flex;
  min-height: 200px;
  border-bottom: 2px solid #231815;
}

.fp-hj {
  display: flex;
  height: 40px;
  border-bottom: 2px solid #231815;
}

.right {
  border-right: 2px solid #231815;
}

.gmf {
  width: 50px;
  padding: 10px 15px;
  box-sizing: border-box;
  font-size: 20px;
}

.ddxx {
  width: 32px;
  padding: 0px 5px;
  box-sizing: border-box;
  font-size: 18px;
}

.bz {
  width: 32px;
  padding: 15px 5px;
  box-sizing: border-box;
  font-size: 18px;
  line-height: 40px;
}

.gmf-content {
  width: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.ddxx-content {
  display: flex;
  flex-direction: column;
  /*justify-content: center;*/
}

.bz-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.column {
  display: flex;
  align-items: center;
  padding: 0 2px;
}

.top {
  margin-top: 2px;
}

.goods-column {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.container >>> .vxe-input--inner {
  font-size: 12px;
  font-family: Microsoft YaHei, sans-serif;
  font-weight: 600;
  color: #3346a2;
}

.plateForm >>> .link-text {
  font-size: 12px;
  font-family: Microsoft YaHei, sans-serif;
  font-weight: 600;
  color: #3346a2;
}

.salesMan >>> .link-text {
  width: 110px;
  text-align: center;
  font-size: 12px;
  font-family: Microsoft YaHei, sans-serif;
  font-weight: 600;
  color: #3346a2;
}

.link-text {
  font-size: 12px;
  font-family: Microsoft YaHei, sans-serif;
  font-weight: 600;
  color: #3346a2;
}

.invoiceType >>> .vxe-input {
  height: 40px;
}

.invoiceType >>> .vxe-input--inner {
  font-size: 26px;
  font-family: FangSong, sans-serif;
  font-weight: 600;
  color: #231815;
  text-align: center;
}

.no >>> .vxe-input--inner {
  font-size: 24px;
  font-family: Microsoft YaHei, sans-serif;
  font-weight: 400;
  color: #3346a2;
}

.fp-right {
  font-size: 16px;
  font-family: FangSong, sans-serif;
  font-weight: 600;
  color: #352e2c;
  width: 20px;
  margin: 80px 0 0 5px;
  line-height: 24px;
  word-wrap: break-word;
}

.kd {
  font-size: 14px;
  font-family: Microsoft YaHei, sans-serif;
  font-weight: 600;
  color: #352e2c;
  display: flex;
  align-items: center;
}
</style>
